/**
 * One labelled control in a Create * drawer. Spacing lives on the drawer body.
 *
 * @param {{children: *}} props
 * @return {*}
 */
export const QuickCreateFieldRow = ({ children }) => <div className="fieldRow">{children}</div>;
